export class Commune {
    constructor(
        public codeInsee?: string,
        public libelle?: string,
        public libelleEdition?: string,
        public codePostal?: string,
        public departement?: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/commune.model.ts